import React, { ReactNode, useEffect, useState } from "react";
import { proxyAPI } from "../proxyAPI";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Offcanvas, OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { truncate } from "../helpers";
import timezones from "../Builder/nodes/Logic/timezones";
import { setCurrentModal } from "../store/slices/modalsSlice";
import EmailIcon from "../../assets/icons/icon_email-01.svg2";
import MessageIcon from "../../assets/icons/messages.svg2";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import WhatsAppIcon from "../../assets/icons/whatsapp.svg2";
import MessangerIcon from "../../assets/icons/messenger.svg2";
import RcsIcon from "../../assets/icons/sms_text.svg2";
import ContactIcon from "../../assets/icons/prepaid.svg2";
import MyIcon from "../Common/MyIcon";

const getFieldValue = (field: any, value: any) => {
  const { countries } = JSON.parse(
    (document.querySelector("#app") as any).dataset.page
  ).props;

  if (field.isSelect) {
    if (field.selectType === "country") {
      return countries.find(
        (c: { country_code: string }) => c.country_code === value.data
      ).country_name;
    }
    if (field.selectType === "time-zone") {
      return (
        timezones.find((tz) => tz.tzCode === value.data)?.label ?? value.data
      );
    }
    return (
      field.options?.find((o: { uuid: any }) => o.uuid === value.data)?.label ??
      value.data
    );
  }
  return value.data;
};

function ContactCard({ contact, contactButton, isModal }: any) {
  const dispatch = useDispatch();
  const contactSets = contact?.contactSets || [];
  const setContactSetModalData = (d: { uuid: any; onClose: () => null }) => {
    dispatch(setCurrentModal({ modal: "contactSet", data: d }));
  };

  return (
    <div>
      {contactButton && <div className="p-2">{contactButton(contact)}</div>}

      <div className="p-2">
        <span className="rounded-pill text-bg-dark px-2 py-1 text-uppercase small text-nowrap w-100 d-inline-block fw-bold">
          <FontAwesomeIcon
            icon={faCircle}
            className={`${contact.status === "active" ? "text-success" : ""}${
              contact.status === "incomplete" ? "text-warning" : ""
            } me-2`}
          />
          {contact.status}
        </span>
      </div>

      {contact.details
        .sort(
          (
            a: {
              field: any;
            },
            b: {
              field: any;
            }
          ) => a.field.order - b.field.order
        )
        .map((detail: { field: any; values: { data: string }[] }) => {
          return (
            <div key={`${contact.uuid}-${detail.field.uuid}`} className="p-2">
              <span className="text-secondary me-2">
                {detail.field.label}: {}{" "}
              </span>
              {detail.values.map((value: { data: string }, index: number) => (
                <span
                  key={`${contact.uuid}-${detail.field.uuid}-${index}`}
                  className="text-nowrap"
                >
                  <OverlayTrigger
                    trigger="click"
                    placement="top"
                    rootClose
                    overlay={
                      <Popover
                        id={`${contact.uuid}-${detail.field.uuid}-value-popover`}
                        className="p-2"
                        style={{ zIndex: 15000 }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div>{getFieldValue(detail.field, value)}</div>
                      </Popover>
                    }
                  >
                    <span className="btn p-0 d-inline-block">
                      {truncate(getFieldValue(detail.field, value))}
                    </span>
                  </OverlayTrigger>

                  {index < detail.values.length - 1 ? (
                    <span className="mx-2">/</span>
                  ) : (
                    ""
                  )}
                </span>
              ))}
            </div>
          );
        })}

      <>
        <div className="text-nowrap p-2">
          <span className="text-secondary me-2">Belongs to groups:</span>
          <OverlayTrigger
            trigger="click"
            placement="top"
            rootClose
            overlay={
              <Popover
                id={`${contact.uuid}-groups-popover`}
                className="p-2"
                style={{ zIndex: 15000 }}
                onClick={(e) => e.stopPropagation()}
              >
                {contactSets.map(
                  (cs: {
                    uuid: React.Key | null | undefined;
                    label:
                      | string
                      | number
                      | boolean
                      | React.ReactElement<
                          any,
                          string | React.JSXElementConstructor<any>
                        >
                      | Iterable<React.ReactNode>
                      | null
                      | undefined;
                    type:
                      | string
                      | number
                      | boolean
                      | React.ReactElement<
                          any,
                          string | React.JSXElementConstructor<any>
                        >
                      | Iterable<React.ReactNode>
                      | React.ReactPortal
                      | null
                      | undefined;
                    membersCount:
                      | string
                      | number
                      | boolean
                      | React.ReactElement<
                          any,
                          string | React.JSXElementConstructor<any>
                        >
                      | Iterable<React.ReactNode>
                      | React.ReactPortal
                      | null
                      | undefined;
                  }) => (
                    <div className="text-nowrap" key={cs.uuid}>
                      {isModal ? (
                        <button
                          type="button"
                          onClick={() =>
                            setContactSetModalData({
                              uuid: cs.uuid,
                              onClose: () => null,
                            })
                          }
                          className="btn btn-link px-0"
                        >
                          {cs.label}
                        </button>
                      ) : (
                        <Link to={`/assets/contacts/groups/${cs.uuid}`}>
                          {cs.label}
                        </Link>
                      )}
                      - {cs.type} - {cs.membersCount} members
                    </div>
                  )
                )}
              </Popover>
            }
          >
            <span
              className="btn p-0 d-inline-block text-truncate"
              style={{ maxWidth: 120 }}
            >
              {contactSets.length}
            </span>
          </OverlayTrigger>
        </div>

        <div className="text-nowrap p-2">
          <span className="text-secondary me-2">Created at:</span>
          {new Date(
            `${contact.createdAt.split(" ")[0]}T${
              contact.createdAt.split(" ")[1]
            }${contact.createdAt.split(" ")[2]}`
          ).toLocaleString()}
        </div>
      </>
    </div>
  );
}

function SingleContactCard2({ uuid }: { uuid: string }) {
  const [contact, setContact] = useState<{ details: any } | null>(null);

  const getContact = async () => {
    const data = await proxyAPI({
      prefix: "contacts/v1",
      url: `/first/${uuid}?fields.cards=1&fields.channels=1`,
    });
    setContact(data);
  };

  useEffect(() => {
    getContact();
  }, []);

  const contactFields = contact?.details
    .map((d: any) => d.field)
    .sort((a: any, b: any) => a.order - b.order);

  return (
    contact && (
      <ContactCard
        contact={contact}
        contactButton={() => (
          <Link to={`/assets/contacts/edit/${uuid}`}>
            <FontAwesomeIcon icon={faPen} />
          </Link>
        )}
        isModal={false}
      />
    )
  );
}

export default function SingleContactCard({ uuid }: { uuid: string }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <button
        type="button"
        className="btn p-0"
        onClick={handleShow}
      ><MyIcon Icon={ContactIcon} width={15} /></button>
       

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Contact Information</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SingleContactCard2 uuid={uuid} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
